{
  "dashboard": "Dashboard",
  "orders": "Orders",
  "csvVendorOverride": "CSV Vendor Override",
  "merchants": "Merchants",
  "vendors": "Vendors",
  "stores": "Stores",
  "orderList": "Order List",
  "orderSettings": "Order Settings",
  "vendorMapping": "Vendor Mapping",
  "auditLog": "Audit log",
  "shipping": {
    "group": "Shipping",
    "price": "Shipping Price",
    "trackRouting": "Track Routing",
    "config": "Config",
    "rateTable": "Rate Table",
    "rateTable2": "Rate Table 2",
    "rt2Routing": "Routing",
    "rt2Margin": "Margin Report",
    "rt2History": "History",
    "rt2Rate": "Rate Table",
    "comingSoon": "Coming soon"
  },
  "billing": "Billing",
  "settings": "Settings",
  "groups": {
    "finance": "Finance",
    "billing": "Billing",
    "products": "Blueprints",
    "pricing": "Pricing",
    "reports": "Reports",
    "system": "System",
    "support": "Support",
    "operations": "Operations",
    "salesCrm": "Sales / CRM",
    "affiliate": "Affiliate",
    "homeManagement": "Home Management",
    "monitoring": "Monitoring"
  },
  "finance": {
    "invoices": "Invoices",
    "agingReport": "Aging Report",
    "creditMemos": "Credit Memos",
    "refundTasks": "Refund Tasks",
    "pendingApprovals": "Pending Approvals",
    "paymentRequests": "Payment Requests",
    "transactions": "Transactions",
    "payouts": "Vendor Payouts",
    "topupReviews": "Top-up Reviews",
    "credits": "Credits",
    "gateways": "Payment Gateways",
    "transferGroups": "Transfer Groups",
    "legalEntities": "Legal Entities",
    "topupQueue": "Top-up Queue",
    "withdrawQueue": "Merchant Withdrawals",
    "chargebacks": "Chargebacks",
    "fraudSettings": "Fraud Settings",
    "whitelist": "Whitelist",
    "imapConfig": "IMAP Config",
    "fxRates": "FX Rates"
  },
  "products": {
    "categories": "Categories",
    "blueprints": "Blueprints",
    "options": "Options",
    "productApproval": "Product Approval",
    "productsSpecial": "Products Special",
    "bundles": "Bundles",
    "mapping": "Mapping",
    "collections": "Collections",
    "addOns": "Add-ons",
    "pricing": "Pricing",
    "techniques": "Techniques",
    "templates": "Templates",
    "root": "Products",
    "materials": "Materials",
    "regionErrors": "Region Errors",
    "checkTypes": "Check Types",
    "printAreas": "Print Areas",
    "locations": "Locations"
  },
  "pricing": {
    "prices": "Prices",
    "pricesV2": "Prices V2",
    "blueprintCost": "Blueprint Cost",
    "packingGroups": "Packing Groups",
    "pricingConfig": "Pricing Config"
  },
  "reports": {
    "analytics": "Analytics",
    "orderWarnings": "Order Warnings",
    "syncErrorReports": "Sync Error Reports",
    "auditLogs": "Audit Logs",
    "accountantActivity": "Accountant Activity",
    "exportCenter": "Export Center"
  },
  "system": {
    "users": "Users",
    "roles": "Roles",
    "settings": "System Settings",
    "announcements": "Announcements",
    "dualApproval": "Dual Approval Queue",
    "emailTemplates": "Email Templates",
    "rolesMatrix": "Roles & Permissions",
    "adminMgmt": "Admin Management",
    "featureFlags": "Feature Flags",
    "health": "System Health",
    "maintenance": "Maintenance Mode",
    "bugTracker": "Bug Tracker"
  },
  "support": {
    "dashboard": "Support Dashboard",
    "tickets": "Tickets",
    "departments": "Department queue",
    "inbox": "Inbox",
    "performance": "Performance",
    "configurations": "Configurations"
  },
  "assignSalesCs": "Assign Sales & CS",
  "navAria": "Admin navigation",
  "superAdminOnly": "Super Admin only",
  "operations": {
    "shipmentTracking": "Shipment Tracking",
    "pendingManualAssign": "Pending Manual Assign"
  },
  "sales": {
    "overview": "Overview",
    "leads": "Leads",
    "deals": "Deals",
    "salerGroups": "Saler Groups",
    "calendar": "Calendar",
    "targets": "Targets",
    "leaderboard": "Leaderboard",
    "gmvReport": "GMV Report",
    "operations": "Operations",
    "merchants": "Sales Merchants",
    "benefits": "Benefits",
    "reports": "Reports",
    "settings": "Settings"
  },
  "affiliate": {
    "hub": "Affiliate Hub",
    "list": "Affiliate List",
    "payoutQueue": "Payout Queue",
    "shortLinks": "Short Links",
    "abuseReport": "Abuse Report"
  },
  "homeManagement": {
    "homepage": "Homepage",
    "ebooks": "Ebooks",
    "blog": "Blog",
    "help": "Help Center",
    "stories": "Stories",
    "faq": "FAQ",
    "sellerSurvey": "Seller Survey",
    "footer": "Footer",
    "contact": "Contact",
    "pages": "Pages"
  },
  "inventory": {
    "overview": "Inventory Overview",
    "group": "Inventory",
    "stockLevel": "Stock Levels",
    "valuation": "Valuation",
    "movement": "Movement",
    "aging": "Aging",
    "turnover": "Turnover"
  },
  "monitoring": {
    "queueJobs": "Queue & Jobs",
    "webhookLogs": "Webhook Logs",
    "syncErrors": "Sync Errors",
    "imapParser": "IMAP Parser"
  },
  "vendorsServices": "Service"
}
